import ContentLoader from 'react-content-loader';
import ExamFeedback from '../../../../../core/components/templates/Exam/Feedback';
import { useRevisionSSRExamFeedbackHook } from '../../../hooks/Revision/SSR/ssrExamFeedback';
import Container from '../../../../../core/components/atoms/Container';

const RevisionExamFeedback = () => {
  const {
    exercises,
    correctAnswersPercentage,
    correctAnswersTotal,
    wrongAnswersTotal,
    timeSpent,
    isLoading,
    remakeExam,
    goToRevisionList,
  } = useRevisionSSRExamFeedbackHook();

  if (isLoading) {
    return (
      <Container>
        <ContentLoader
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 30'
        >
          <rect x='0' y='2' rx='2' ry='2' width='100' height='15' />
        </ContentLoader>
        <ContentLoader
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 80'
        >
          <rect x='0' y='2' rx='2' ry='2' width='100%' height='70' />
        </ContentLoader>
        {Array.from({ length: 5 }, (_, index) => (
          <ContentLoader
            key={`${index}_loader`}
            backgroundColor={'#a7adba'}
            foregroundColor={'#c0c5ce'}
            viewBox='0 0 500 24'
          >
            <rect x='0' y='2' rx='2' ry='2' width='100%' height='20' />
          </ContentLoader>
        ))}
      </Container>
    );
  }

  return (
    <ExamFeedback
      exercises={exercises}
      onRemake={() => remakeExam()}
      onRevision={() => goToRevisionList()}
      correctAnswersPercentage={correctAnswersPercentage}
      correctAnswersTotal={correctAnswersTotal}
      wrongAnswersTotal={wrongAnswersTotal}
      timeSpent={timeSpent}
    />
  );
};
export default RevisionExamFeedback;
